import PaginatedList from '@theme/paginated-list';

export default class BlogPostsList extends PaginatedList {
  constructor() {
    super();

    this.allArticles = window.RESOURCES_DATA || [];
    this.results = [...this.allArticles];

    this.grid = this.querySelector('[ref="grid"]');
    this.filterButtons = document.querySelectorAll(".filter-btn");
    this.searchInput = document.querySelector("#blog-search");
    this.searchActionBtn = document.querySelector("#search-action-btn");
    this.searchIcon = this.querySelector(".search-icon");
    this.clearIcon = this.querySelector(".clear-icon");

    this.currentTag = this.getInitialFilterFromURL();
    this.searchQuery = "";

    this.bindEvents();
    this.syncActiveButton();
    this.renderPage(true);
    this.updateButtonIcon();
    this.applyFilter();
  }

  bindEvents() {
    this.filterButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.filterButtons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        this.currentTag = btn.dataset.tag;
        this.updateURL();
        this.applyFilter();
      });
    });

    this.searchInput.addEventListener("input", (e) => {
      this.searchQuery = e.target.value.toLowerCase();
      this.updateButtonIcon();
      this.applyFilter();
    });

    this.searchInput.addEventListener("keypress", (e) => {
      if (e.key === 'Enter') {
        this.applyFilter();
      }
    });

    this.searchActionBtn.addEventListener("click", () => {
      if (this.searchQuery.trim() !== "") {
        this.clearSearchInput();
      } else {
        this.applyFilter();
      }
    });
  }

  updateButtonIcon() {
    if (this.searchQuery.trim() !== "") {
      this.searchIcon.style.display = "none";
      this.clearIcon.style.display = "block";
    } else {
      this.searchIcon.style.display = "block";
      this.clearIcon.style.display = "none";
    }
  }

  clearSearchInput() {
    this.searchInput.value = "";
    this.searchQuery = "";
    this.updateButtonIcon();
    this.applyFilter();
  }

  applyFilter() {
    this.results = this.allArticles.filter((article) => {
      const matchesTag = this.currentTag === "All" || article.tags.includes(this.currentTag);
      const matchesSearch = !this.searchQuery ||
          article.title.toLowerCase().includes(this.searchQuery) ||
          (article.content_html && article.content_html.toLowerCase().includes(this.searchQuery));
      return matchesTag && matchesSearch;
    });

    this.renderPage(true);
  }

  renderPage(reset = false) {
    const items = this.results;
    if (reset) this.grid.innerHTML = "";

    if (items.length === 0) {
      const urlParams = new URLSearchParams(window.location.search);
      const tab = urlParams.get('tab') ?? 'updates';
      this.grid.innerHTML = `<div class="no-results">No results in ${tab}</div>`;

      return;
    }

    items.forEach((blog) => {
      const html = this.renderBlog(blog);
      this.grid.insertAdjacentHTML("beforeend", html);
    });
  }

  renderBlog(blog) {
    const decodedContent = this.renderHtml(blog.content_html || '');

    return `
      <div class="blog-post-item">
        <a class="blog-post-detail" href="${blog.url}">
          <h3>${blog.title}</h3>
          <div class="blog-content">${decodedContent}</div>
        </a>
        <div class="blog-post-read-more">
          <a class="button" href="${blog.url}">Read more</a>
        </div>
      </div>
    `;
  }

  renderHtml(html) {
    if (!html) return '';

    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
  }

  getInitialFilterFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    
    if (tabParam === 'updates') return 'Updates';
    if (tabParam === 'reviews') return 'Reviews';
    if (tabParam === 'press-media') return 'Press & Media';
    if (tabParam === 'team') return 'Team';
    if (tabParam === 'all') return 'All';
    
    return 'Updates'; // default
  }

  syncActiveButton() {
    // Remove active class from all buttons
    this.filterButtons.forEach((btn) => btn.classList.remove("active"));
    
    // Add active class to the button matching current tag
    this.filterButtons.forEach((btn) => {
      if (btn.dataset.tag === this.currentTag) {
        btn.classList.add("active");
      }
    });
  }

  updateURL() {
    const baseUrl = window.location.origin + window.location.pathname;
    let newUrl = baseUrl;
    
    // Add current filter param with tab= format
    switch(this.currentTag) {
      case 'Updates':
        newUrl += '?tab=updates';
        break;
      case 'Reviews':
        newUrl += '?tab=reviews';
        break;
      case 'Press & Media':
        newUrl += '?tab=press-media';
        break;
      case 'Team':
        newUrl += '?tab=team';
        break;
      case 'All':
        newUrl += '?tab=all';
        break;
    }
    
    // Update URL without page reload
    window.history.pushState({}, '', newUrl);
  }
}

if (!customElements.get("blog-posts-list")) {
  customElements.define("blog-posts-list", BlogPostsList);
}
